/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_SubtitleInputs */

const es_components_payment_choice_modal_subtitle = /** @type {(inputs: Components_Payment_Choice_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegí cómo abonar tu nuevo plan.`)
};

const en_components_payment_choice_modal_subtitle = /** @type {(inputs: Components_Payment_Choice_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to pay for your new plan.`)
};

/**
* | output |
* | --- |
* | "Choose how to pay for your new plan." |
*
* @param {Components_Payment_Choice_Modal_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_subtitle = /** @type {((inputs?: Components_Payment_Choice_Modal_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_subtitle(inputs)
	return en_components_payment_choice_modal_subtitle(inputs)
});
export { components_payment_choice_modal_subtitle as "components.payment_choice_modal.subtitle" }